
seedWebServices.service('AllocService', ['$http', '$uibModal',
    function ($http, $uibModal) {

        this.getMonth = function (months) {
            var date = new Date();
            var newDate = new Date(date.setMonth(date.getMonth() + months));
            return newDate;
        };

        this.getMaxIndex = function (details) {
            var maxIndex = 0;
            for (var i = 0; i < details.length; i++) {
                if (details[i].Index > maxIndex) {
                    maxIndex = details[i].Index;
                }
            }
            return maxIndex;
        };

        this.addLine = function (item, periods, materialID, quantity) {
            //console.log('allocService.ADDLINE');
            if (!item.Details) {
                item.Details = [];
            }
            //var index = item.Details.length;
            var index = this.getMaxIndex(item.Details) + 1;
            var detail = {
                MaterialID: null,
                QtOrder: 0,
                QtBefore: [0, 0, 0, 0],
                Quantities: [],
                QtMissing: 0,
                Months: periods,
                StatusID: item.StatusID,
                Index: index,
            };
            //INSERE 1A QUANTIDADE, MELHOR LAYOT
            var newQtd = {
                EDD: this.getMonth(0),
                Quantity: 0,
            };

            if (materialID) {
                detail.MaterialID = materialID;
            }
            if (quantity) {
                detail.QtOrder = quantity;
            }
            detail.Quantities.push(newQtd);
            item.Details.push(detail);
            var selIndex = item.Details.length - 1;
            //var selIndex = index;
            return selIndex;
        };

        this.monthNames = [
            'JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'
        ];
        this.getMonthName = function (month) {
            //console.log('getPeriod');
            if (month) {
                return this.monthNames[month - 1];
            }
        };

        this.isExpired = function (expDate) {
            var today = new Date();
            //today = today.getUTCDate();
            if (this.isExpiring(expDate)) {
                return false;
            }
            else if (expDate < today) {
                return true;
            }
            return false;
        };

        this.isExpiring = function (expDate) {
            var today = new Date();           
            if (this.sameDayUTC(today, expDate)) {
                return true;
            }
            return false;
        };

        this.getExpiredClass = function (expDate) {
            if (!expDate) {
                return '';
            }
            if (this.isExpiring(expDate)) {
                return 'is-expiring';
            }
            if (this.isExpired(expDate)) {
                return 'is-expired';
            }
            return '';
        };

        this.sameDayUTC = function (d1, d2) {
            if (!d1) {
                return false;
            }
            if (!d2) {
                return false;
            }
            return d1.getUTCFullYear() === d2.getUTCFullYear() &&
                d1.getUTCMonth() === d2.getUTCMonth() &&
                d1.getUTCDate() === d2.getUTCDate();
        };

        //this.yesterdayUTC = function () {
        //    var expDate = new Date();            
        //    return new Date(expDate.getUTCFullYear(), expDate.getUTCMonth(), expDate.getUTCDate() - 1);
        //};

        this.nextDayUTC = function (expDate) {
            if (!expDate) {
                return null;
            }
            return new Date(expDate.getUTCFullYear(), expDate.getUTCMonth(), expDate.getUTCDate() + 1);
        };

        this.toUTC = function (aDate) {
            return Date(aDate.getUTCFullYear(), aDate.getUTCMonth(), aDate.getUTCDate());
        };

        this.isLastMonth = function (aDate) {
            if (!aDate) {
                return false;
            }
            var date = new Date();            
            if (aDate.getUTCFullYear() < date.getUTCFullYear() || aDate.getUTCMonth() < date.getUTCMonth()) {
                return true;
            }
            return false;

            //var lastDay = new Date(date.getUTCFullYear(), date.getUTCMonth(), 1);
            //var uDate = this.toUTC(aDate);
            //if (uDate < lastDay) {
            //    console.log('isLastMonth.date ' + aDate + ' firstDay ' + lastDay);
            //    return true;
            //}
            //return false;
        };

        this.getNextMonths = function () {
            var months = [];
            months.push(this.getMonth(0));
            months.push(this.getMonth(1));
            months.push(this.getMonth(2));
            months.push(this.getMonth(3));

            return months;
        };

        this.changeStatusModal = function (order, details, statusID) {
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/orderStatusModal.html',
                controller: 'OrderStatusModalCtrl',
                size: 'md',
                resolve: {
                    order: function () {
                        return order;
                    },
                    details: function () {
                        return details;
                    },
                    statusID: function () {
                        return statusID;
                    },
                }
            });

            //modalInstance.result.then(function (newStatusID) {
            //    console.log('ALLOCSERVICE.RESULT.THEN ' + newStatusID);
            //    //if (newStatusID) {
            //    //    order.isEditing = true;
            //    //    console.log('NEWSTATUSID ' + newStatusID);
            //    //}
            //});

            return modalInstance;
        };

        this.editExpiredJustification = function (order) {
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/orderExpiredJustification.html',
                controller: 'OrderExpiredJustificationCtrl',
                size: 'md',
                resolve: {
                    order: function () {
                        return order;
                    }
                }
            });

            return modalInstance;
        };

        this.formatPrice = function (value, currencyFormat) {
            if (!value) {
                value = 0;
            } else {
                var thousands = ['', 'K', 'M', 'B', 'T'];
                var thousand = 0;
                while (value / 1000 >= 1) {
                    value /= 1000;
                    thousand++;
                }
                value = (Math.round((value + Number.EPSILON) * 10) / 10).toString() + thousands[thousand]; // limit to 1 decimal case
            }
            return currencyFormat ? 'R$' + value : value;
        };

        this.requestOrderRenovate = function (order, renovateStatusID) {
            //order.RenovateStatusID = null;
            var modalInstance = $uibModal.open({
                templateUrl: './SPA/orders/orderRenovateModal.html',
                controller: 'OrderRenovateModalCtrl',
                size: 'md',
                resolve: {
                    order: function () {
                        return order;
                    },
                    renovateStatusID: function () {
                        return renovateStatusID;
                    },
                }
            });

            return modalInstance;
        };


    }]
);